import {useState, useEffect} from 'react'

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ModalDialog from "components/ModalDialog/ModalDialog";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import SurveysTableData from "layouts/retailerSurveys/data/surveysTableData";
import ModalSurveyData from "layouts/retailerSurveys/data/modalSurveyData"

import { useTokenContext } from 'App';
import { getMySurveys } from 'api/surveys/getSurvey';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

function RetailerSurveys() {
  const {token} = useTokenContext();
  const [surveys, setSurveys] = useState(null);
  const [survey, setSurvey] = useState(null)
  const [showModal, setShowModal] = useState(false);
  const { columns: columns, rows: rows} = SurveysTableData(surveys, onActionClick);
  const modalData = <ModalSurveyData survey={survey}/>


  function formatType(type){
    const lowercaseType =  type.toLowerCase().replace(/_/g, " ")
    return lowercaseType.charAt(0).toUpperCase() + lowercaseType.slice(1)
  }

  function onActionClick(survey){
    setSurvey(survey)
    setShowModal(true);
  }

  const onCloseModalClick = () =>{
    setShowModal(false);
  }
  
  const doGetMySurveys = async () => {
    try {
      let surveysPromise = await getMySurveys(token);
      setSurveys(surveysPromise)

    } catch (error) {
      console.error("Error on get my surveys: ", error);
    }
  }

  useEffect(() => {
    doGetMySurveys();
  },[]);

  return (
    <>
    {(columns && rows) && (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: columns, rows: rows }}
                  isSorted={false}
                  canSearch={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {showModal && 
      <>
      {(survey['survey_definition']['survey_name'] === "PERSONAL_DATA_SURVEY" || survey['survey_definition']['survey_name'] === "PRODUCT_DEFAULT_SURVEY") ?
      <ModalDialog 
        onCloseModalClick={onCloseModalClick} 
        title={formatType(survey["survey_definition"]["survey_name"])}
        rightTitle={"System"}
        content={modalData}
      />
      :
      <ModalDialog 
      onCloseModalClick={onCloseModalClick} 
      title={formatType(survey["survey_definition"]["survey_name"])}
      content={modalData}
      />
      }
    </>
    }
    </>
    )} 
    </>
  );
}

export default RetailerSurveys;
